var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import FAIcon from "../FAIcon/FAIcon";
const CompleteButton = (_a) => {
    var { isComplete, isLoading, className, size } = _a, otherProps = __rest(_a, ["isComplete", "isLoading", "className", "size"]);
    return (_jsx("button", Object.assign({ type: "button" }, otherProps, { style: isComplete ? {} : { backgroundColor: "transparent" }, className: "btn " +
            (size ? `btn-${size} ` : "") +
            (isComplete ? "btn-success " : "") +
            (className || ""), 
        // @ts-expect-error - TS2322 - Type 'boolean | null | undefined' is not assignable to type 'boolean | undefined'.
        disabled: isLoading, children: _jsx(FAIcon, { icon: isComplete ? "check-circle" : "square", isLoading: isLoading, size: "lg" }) })));
};
export default CompleteButton;
